import { User } from './../../models/user';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ToastrService } from 'ngx-toastr';
import * as authActions from '../../authModule/state/actions/authentication.actions';
import * as assignmentActions from '../../professor-components/state/assignments/action/assignment.actions';
import * as thesisActions from '../../professor-components/state/thesis/action/thesis.actions';
import * as subjectActions from '../../professor-components/state/subjects/action/subject.actions';
import * as studentActions from '../../professor-components/state/students/action/student.actions';
import * as individualAdministratorActions from '../../individual-administrator-components/state/action/individualAdministrator.actions';

import * as requestsActions from '../../professor-components/state/requests/action/request.actions';

import * as studentRequestsActions from '../../student-components/state/request/action/request.actions';

import * as studentAdministrationActions from '../../student-components/state/administration/action/administration.actions';

import * as facultyActions from '../../administrator-components/state/faculty/action/faculty.actions';
import * as departmentActions from '../../administrator-components/state/department/action/department.actions';
import * as administratorSubjectActions from '../../administrator-components/state/subject/action/subject.actions';
import * as professorActions from '../../administrator-components/state/professor/action/professor.actions';
import * as administratorStudentActions from '../../administrator-components/state/student/action/student.actions';
import * as offersActions from '../../administrator-components/administrator-store/licenses/offers/state/action/offers.actions';

import { tap } from 'rxjs/operators';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

/**
 * Alert Effect responsible to show alert messages based on specific actions
 */
@Injectable()
export class AlertEffects {
   user: any;
   constructor(
      private actions$: Actions,
      private toastrService: ToastrService,
      private store: Store,
      public translate: TranslateService
   ) { }
   /**
    * Effect listening for login, googleLogin, linkedInLogin action. When actions are triggered the effect will trigger toastr Service info method to inform user.
    */
   checkingYourInformation$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(
               authActions.login,
               authActions.googleLogin,
               authActions.linkedInLogin,
               authActions.LTILogin
            ),
            tap(() => this.toastrService.info(this.translate.instant('report.checking_your_information')))
         ),
      { dispatch: false }
   );
   /**
    * Effect listening for successfully login actions (loginSuccess, googleLoginSuccess, linkedInLoginSuccess), when the actions are dispatched effect will trigger toaster Service success() method to welcome user.
    */
   welcomeBack$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(
               authActions.loginSuccess,
               authActions.googleLoginSuccess,
               authActions.linkedInLoginSuccess,
               authActions.LTILoginSuccess
            ),
            tap((action) => {
               this.user = action.user;
               //  if (this.user) {
               //    this.toastrService.success(this.translate.instant('intro.welcome') + ' ' + this.user?.name + ' !');
               //  }
            })
         ),
      { dispatch: false }
   );

   /**
    * Effect listening for successfully login actions (loginSuccess, googleLoginSuccess, linkedInLoginSuccess), when the actions are dispatched effect will trigger toaster Service success() method to welcome user.
    */
   updateUserInfo$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(authActions.updateUserInfoSuccess),
            tap((action) => {
               this.toastrService.success(this.translate.instant('notifications.your_info_updated_successfully'));
            })
         ),
      { dispatch: false }
   );

   createAssignment$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(assignmentActions.createAssignmentSuccess),
            tap((action) => {
               this.toastrService.success(this.translate.instant('notifications.assignment_created_successfully'));
            })
         ),
      { dispatch: false }
   );

   createThesis$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(thesisActions.createThesisSuccess),
            tap((action) => {
               this.toastrService.success(action.data.message);
            })
         ),
      { dispatch: false }
   );

   editAssignment$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(assignmentActions.editAssignmentSuccess),
            tap((action) => {
               this.toastrService.success(this.translate.instant('app.assignment_edited_successfully'));
            })
         ),
      { dispatch: false }
   );

   editThesis$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(thesisActions.editThesisSuccess),
            tap((action) => {
               this.toastrService.success(action.data.message);
            })
         ),
      { dispatch: false }
   );

   createSubject$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(subjectActions.registerSubjectsSuccess),
            tap((action) => {
               // Check if we have a messageKey for translation, otherwise fallback to message
               if (action.data.messageKey) {
                  this.toastrService.success(this.translate.instant('new_entries.' + action.data.messageKey));
               } else if (action.data.message) {
                  this.toastrService.success(action.data.message);
               } else {
                  this.toastrService.success(this.translate.instant('new_entries.course_has_been_created_successfully'));
               }
            })
         ),
      { dispatch: false }
   );

   inviteStudent$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(studentActions.inviteStudentSuccess),
            tap((action) => {
               this.toastrService.success(action.data.message);
            })
         ),
      { dispatch: false }
   );

   deleteSubject$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(subjectActions.deleteSubjectsSuccess),
            tap((action) => {
               // Check if we have a messageKey for translation, otherwise fallback to message
               if (action.data.messageKey) {
                  this.toastrService.success(this.translate.instant('new_entries.' + action.data.messageKey));
               } else if (action.data.message) {
                  this.toastrService.success(action.data.message);
               } else {
                  this.toastrService.success(this.translate.instant('new_entries.subject_has_been_deleted'));
               }
            })
         ),
      { dispatch: false }
   );

   inviteIndividual$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(individualAdministratorActions.inviteStudentSuccess),
            tap((action) => {
               this.toastrService.success(action.data.message);
            })
         ),
      { dispatch: false }
   );

   deleteAssignment$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(assignmentActions.deleteAssignmentSuccess),
            tap((action) => {
               this.toastrService.success(action.data.message);
            })
         ),
      { dispatch: false }
   );

   EditIndividualDetails$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(individualAdministratorActions.editStudentSuccess),
            tap((action) => {
               this.toastrService.success(action.data.message);
            })
         ),
      { dispatch: false }
   );

   deleteThesis$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(thesisActions.deleteThesisSuccess),
            tap((action) => {
               this.toastrService.success(action.data.message);
            })
         ),
      { dispatch: false }
   );

   editSubject$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(subjectActions.editSubjectsSuccess),
            tap((action) => {
               // Check if we have a messageKey for translation, otherwise fallback to message
               if (action.data.messageKey) {
                  this.toastrService.success(this.translate.instant('new_entries.' + action.data.messageKey));
               } else if (action.data.message) {
                  this.toastrService.success(action.data.message);
               } else {
                  this.toastrService.success(this.translate.instant('new_entries.subject_has_been_edited'));
               }
            })
         ),
      { dispatch: false }
   );

   duplicateSubject$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(subjectActions.duplicateSubjectsSuccess),
            tap((action) => {
               // Check if we have a messageKey for translation, otherwise fallback to message
               if (action.data.messageKey) {
                  this.toastrService.success(this.translate.instant('new_entries.' + action.data.messageKey));
               } else if (action.data.message) {
                  this.toastrService.success(action.data.message);
               } else {
                  this.toastrService.success(this.translate.instant('new_entries.subject_duplicated_successfully'));
               }
            })
         ),
      { dispatch: false }
   );

   toggleSubmissionAccess$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(
               individualAdministratorActions.toggleSubmissionAccessSuccess
            ),
            tap((action) => {
               this.toastrService.success(action.data.message);
            })
         ),
      { dispatch: false }
   );

   studentRegisterSubject$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(studentAdministrationActions.registerSubjectSuccess),
            tap((action) => {
               this.toastrService.success(action.data.message);
            })
         ),
      { dispatch: false }
   );

   studentRequest$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(studentRequestsActions.sentRequestSuccess),
            tap((action) => {
               // Check if we have a messageKey for translation, otherwise fallback to message
               if (action.data.messageKey) {
                  this.toastrService.success(this.translate.instant('new_entries.' + action.data.messageKey));
               } else if (action.data.message) {
                  this.toastrService.success(action.data.message);
               } else {
                  // Default fallback based on the action type
                  this.toastrService.success(this.translate.instant('new_entries.your_request_has_been_sent'));
               }
            })
         ),
      { dispatch: false }
   );

   studentRequestApprove$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(requestsActions.approveRequestsSuccess),
            tap((action) => {
               // Check if we have a messageKey for translation, otherwise fallback to message
               if (action.data.messageKey) {
                  this.toastrService.success(this.translate.instant('new_entries.' + action.data.messageKey));
               } else if (action.data.message) {
                  this.toastrService.success(action.data.message);
               } else {
                  // Default fallback based on the action type
                  this.toastrService.success(this.translate.instant('new_entries.request_approved'));
               }
            })
         ),
      { dispatch: false }
   );

   facultyRegistration$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(facultyActions.facultiesRegisterSuccess),
            tap((action) => {
               this.toastrService.success(this.translate.instant('notifications.institution_created_successfully'));
            })
         ),
      { dispatch: false }
   );

   facultyEdit$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(facultyActions.editFacultyDetailsSuccess),
            tap((action) => {
               this.toastrService.success(this.translate.instant('notifications.institution_edited_successfully'));
            })
         ),
      { dispatch: false }
   );

   facultyRemove$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(facultyActions.removeFacultySuccess),
            tap((action) => {
               this.toastrService.success(this.translate.instant('notifications.institution_removed_successfully'));
            })
         ),
      { dispatch: false }
   );

   departmentRegistration$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(departmentActions.departmentsRegisterSuccess),
            tap((action) => {
               this.toastrService.success(this.translate.instant('notifications.department_created_successfully'));
            })
         ),
      { dispatch: false }
   );

   departmentEdit$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(departmentActions.editDepartmentDetailsSuccess),
            tap((action) => {
               this.toastrService.success(this.translate.instant('notifications.department_edited_successfully'));
            })
         ),
      { dispatch: false }
   );

   departmentRemove$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(departmentActions.removeDepartmentSuccess),
            tap((action) => {
               this.toastrService.success(this.translate.instant('notifications.department_removed_successfully'));
            })
         ),
      { dispatch: false }
   );

   subjectRegistration$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(administratorSubjectActions.subjectsRegisterSuccess),
            tap((action) => {
               this.toastrService.success(this.translate.instant('notifications.subject_created_successfully'));
            })
         ),
      { dispatch: false }
   );

   subjectEdit$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(administratorSubjectActions.editSubjectDetailsSuccess),
            tap((action) => {
               this.toastrService.success(this.translate.instant('app.subject_edited_successfully'));
            })
         ),
      { dispatch: false }
   );

   subjectRemove$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(administratorSubjectActions.removeSubjectSuccess),
            tap((action) => {
               this.toastrService.success(this.translate.instant('notifications.subject_removed_successfully'));
            })
         ),
      { dispatch: false }
   );

   professorRegistration$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(professorActions.professorRegisterSuccess),
            tap((action) => {
               this.toastrService.success(this.translate.instant('notifications.professor_registered_successfully'));
            })
         ),
      { dispatch: false }
   );

   professorEdit$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(professorActions.editProfessorDetailsSuccess),
            tap((action) => {
               this.toastrService.success(this.translate.instant('notifications.professor_edited_successfully'));
            })
         ),
      { dispatch: false }
   );

   professorRemove$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(professorActions.removeProfessorSuccess),
            tap((action) => {
               this.toastrService.success(this.translate.instant('notifications.professor_removed_successfully'));
            })
         ),
      { dispatch: false }
   );

   studentRegistration$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(administratorStudentActions.studentRegisterSuccess),
            tap((action) => {
               this.toastrService.success(action.message);
            })
         ),
      { dispatch: false }
   );

   studentEdit$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(administratorStudentActions.editStudentDetailsSuccess),
            tap((action) => {
               this.toastrService.success(this.translate.instant('notifications.student_edited_successfully'));
            })
         ),
      { dispatch: false }
   );

   studentRemove$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(administratorStudentActions.removeStudentSuccess),
            tap((action) => {
               this.toastrService.success(this.translate.instant('notifications.student_removed_successfully'));
            })
         ),
      { dispatch: false }
   );

   professorStudentRegister$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(studentActions.registerStudentSuccess),
            tap((action) => {
               this.toastrService.success(action.data.message);
            })
         ),
      { dispatch: false }
   );
   inviteStudents$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(studentActions.inviteStudentsSuccess),
            tap(async (action) => {
               if (!action.data.message) {
                  this.toastrService.info(this.translate.instant('notifications.list_of_the_students_you_want_to_invite'));
               } else {
                  this.toastrService.success(this.translate.instant('notifications.students_invited_successfully'));
               }
            })
         ),
      { dispatch: false }
   )

   offerCreated$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(offersActions.createOfferSuccess),
            tap((action) => {
               this.toastrService.success(this.translate.instant('notifications.your_offer_created_successfully'));
            })
         ),
      { dispatch: false }
   );

   offerEdites$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(offersActions.editOfferSuccess),
            tap((action) => {
               this.toastrService.success(this.translate.instant('notifications.your_offer_edited_successfully'));
            })
         ),
      { dispatch: false }
   );

   offerDeleted$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(offersActions.sentEmailForCustomOfferSuccess),
            tap((action) => {
               this.toastrService.success(this.translate.instant('login.email_sent'));
            })
         ),
      { dispatch: false }
   );

   emailSentForOffer$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(offersActions.deleteOffer),
            tap((action) => {
               this.toastrService.success(this.translate.instant('notifications.your_offer_has_been_deleted'));
            })
         ),
      { dispatch: false }
   );


}
